import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const ORG_BRANDED_LANDING_COPY = {
  DEFAULT_SUBTITLE: 'Predict every match. Compete with your colleagues. Crown a champion.',
  LOADING: 'Loading...',
  ERROR_TITLE_FALLBACK: 'Organization not found',
  ERROR_MESSAGE: 'This link may have expired or the organization is no longer active.',
  GO_HOME_LABEL: 'Go to Zporti',
  JOIN_CTA_LABEL: 'Join the company squad',
  JOIN_CTA_TEST_ID: 'org-landing-join',
  SIGN_IN_LABEL: 'I already have an account',
  SIGN_IN_TEST_ID: 'org-landing-sign-in',
  PRESENTED_BY_PREFIX: 'Presented by ',
  MEMBER_COUNT_LABEL: 'Be the first to pick',
} as const;

export const getOrgBrandedLandingTitleSuffix = (): string => `'s ${getWcBrand().NAME}`;

/** Small kicker line inside the brand stub — "{Org}'s WC 2026" for every org
 *  (reuses the suffix helper so iOS App Store branding still applies). */
export const getOrgBrandedLandingKicker = (displayName: string): string =>
  `${displayName}${getOrgBrandedLandingTitleSuffix()}`;

/** Per-org big-title overrides, keyed by lowercase slug. Orgs not listed here
 *  fall back to the default "{Org}'s WC 2026" title. */
const ORG_BRANDED_LANDING_TITLE_OVERRIDES: Readonly<Record<string, string>> = {
  atera: "Ateraball: Predict '26 Cup",
};

/** Big headline for the brand stub: a per-org override when one exists,
 *  otherwise "{Org}'s WC 2026". */
export const getOrgBrandedLandingTitle = (slug: string, displayName: string): string =>
  ORG_BRANDED_LANDING_TITLE_OVERRIDES[slug.toLowerCase()] ??
  `${displayName}${getOrgBrandedLandingTitleSuffix()}`;

export const getOrgBrandedLandingNotSetUpNotice = (): string =>
  `This organization hasn't set up its ${getWcBrand().NAME} squad yet.`;
